export enum CurrencyCodeEnum {
  USD = 'USD',
  EUR = 'EUR',
}
